<template>
  <div>
    <div class="profile">
      <!-- <breadcrumb v-bind:path2="path2"></breadcrumb> -->
      <div class="breadcrumb">
        <p>{{ $t('account') }}</p>
        <i class="fa fa-caret-right" aria-hidden="true"></i>
        <!-- <p>{{path2}}</p> -->
        <p>{{ $t(componentDisplayOnAccount) }}</p>
      </div>
      <div class="content">
        <div class="info">
          <!-- <div class="nav-left"> -->

            <!-- <div class="hello-profile">
              <div class="hello-content">
                <div class="icon-cont">
                 <font-awesome-icon class="icon-hover" icon="user"
                                    :style="{ color: 'white', fontSize: '18px', marginLeft: '30px' }"/>
                  <img src="../../assets/img/profile-button.svg">
                  <p>Hi, {{ this.userDetails.FirstName }}</p>
                </div>
                <p class="delivery">{{ $t('your_favorite_asian') }}</p>
                <div class="accountInfoIcon">
                  <p @click="handleNavToAccountFromNavbar('accountInfoNew')"
                     class="accountInfoNew"
                     :class="{'accountInfoNew-selected':componentDisplayOnAccount === 'accountInfoNew'}"></p>
                </div>
              </div>
            </div>  -->



            <!-- <div class="operating-left">
              <div class="profile-buttons">
                <div class="profile-column">
                  <div
                    :class="componentDisplayOnAccount === 'customerService' ?'profile-img-container-selected': 'profile-img-container'"
                    @click="handleNavToAccountFromNavbar('customerService')"
                  >
                    <img src="../../assets/img/chatbox.svg" style="height: 34px; width: 34px"/>
                    <div v-if="componentDisplayOnAccount==='customerService'" class="customerService-selected"></div>
                    <div v-else class="customerService"></div>
                  </div>
                  <p :class="componentDisplayOnAccount === 'customerService' ?'selected-text': ''">
                    {{ $t('customer_service') }}</p>
                </div>
                <div class="profile-column">
                  <div
                    :class="componentDisplayOnAccount === 'coupon' ?'profile-img-container-selected': 'profile-img-container'"
                    @click="handleNavToAccountFromNavbar('coupon')"
                  >
                    <img src="../../assets/img/coupon.svg" style="height: 34px; width: 34px"/>

                    <div v-if="componentDisplayOnAccount==='coupon'" class="couponIcon-selected"></div>
                    <div v-else class="couponIcon"></div>
                  </div>
                  <p :class="componentDisplayOnAccount === 'coupon' ?'selected-text': ''">{{ $t('coupon') }}</p>
                </div>
                <div class="profile-column">
                  <div
                    :class="componentDisplayOnAccount === 'location' ?'profile-img-container-selected': 'profile-img-container'"
                    @click="handleNavToAccountFromNavbar('location')"
                  >
                    <div v-if="componentDisplayOnAccount==='location'" class="location-selected"></div>
                    <div v-else class="location"></div>
                  </div>
                  <p :class="componentDisplayOnAccount === 'location' ?'selected-text': ''">{{
                      $t('afm_locations')
                    }}</p>
                </div>
                <div class="profile-column">
                  <div
                    :class="componentDisplayOnAccount==='subscription' ?'profile-img-container-selected': 'profile-img-container'"
                    @click="handleNavToAccountFromNavbar('subscription')"
                  >
                    <img src="../../assets/img/subscription.svg" style="height: 34px; width: 34px"/>
                    <div v-if="componentDisplayOnAccount==='subscription'" class="subscriptionIcon-selected"></div>
                    <div v-else class="subscriptionIcon"></div>
                  </div>
                  <p :class="componentDisplayOnAccount === 'subscription' ?'selected-text': ''">
                    {{ $t('email_subscription') }}</p>
                </div>
              </div>
              <div class="header-left">
                <span>SHOP@AFM</span><span style="font-weight: 700;">.COM</span>
              </div>
              <div class="line"></div>
              <ul>
                <li :class="componentDisplayOnAccount==='orders' ?'selected':''"
                    @click="handleNavToAccountFromNavbar('orders')">
                  {{ $t('myOrders') }}
                  <p>></p>
                </li>
                <li :class="componentDisplayOnAccount==='inviteFriends' ?'selected':''"
                    @click="handleNavToAccountFromNavbar('inviteFriends')">
                  {{ $t('inviteFriends') }}
                  <p>></p>
                </li>
                <li :class="componentDisplayOnAccount==='coupons' ?'selected':''" @click="handleNavToAccountFromNavbar('coupons')">
                  {{ $t('coupons') }}
                  <p>></p>
                </li>
                <li :class="componentDisplayOnAccount==='favourites' ?'selected':''" @click="handleNavToAccountFromNavbar('favourites')">
                  <p>{{ $t('favourites') }}</p>
                  <p></p>
                </li>
                <div class="ul-space"></div>
                <li :class="componentDisplayOnAccount==='address' ?'selected':''"
                    @click="handleNavToAccountFromNavbar('address')">
                  {{ $t('address_manage') }}
                  <p>></p>
                </li>
                <li :class="componentDisplayOnAccount==='paymentCards' ?'selected':''"
                    @click="handleNavToAccountFromNavbar('paymentCards')">
                  {{ $t('payment_manage') }}
                  <p>></p>
                </li>
                <li :class="componentDisplayOnAccount==='review' ?'selected':''"
                    @click="handleNavToAccountFromNavbar('review')">
                  {{ $t('review_manage') }}
                  <p>></p>
                </li>
                <li :class="componentDisplayOnAccount==='favourites' ?'selected':''"
                    @click="handleNavToAccountFromNavbar('favourites')">
                  {{ $t('favourites_manage') }}
                  <p>></p>
                </li>
                <li :class="componentDisplayOnAccount==='emailSubscription' ?'selected':''" @click="handleNavToAccountFromNavbar('emailSubscription')">
                {{ $t('emailSubscription') }}
                <p>></p>
              </li>
                <li :class="componentDisplayOnAccount==='accountInformation' ?'selected':''" @click="handleNavToAccountFromNavbar('accountInformation')">
                {{ $t('accountInformation') }}
                <p>></p>
              </li>
                <li @click="logout()" v-if="isMobile" style="color: red;">
                  {{ $t('logOut') }}
                </li>
              </ul>
              <div class="line-mobile"></div>
            </div> -->




          <!-- </div> -->
          <!-- <div class="nav-right"> -->
          <div class="nav-full">
            <Order v-if="componentDisplayOnAccount==='orders'"/>
            <!-- <Address v-if="componentDisplayOnAccount==='address'" /> -->
            <AddressNew v-if="componentDisplayOnAccount==='address'"/>
            <Information v-if="componentDisplayOnAccount==='accountInformation'"/>
            <CustomerService v-if="componentDisplayOnAccount==='customerService'"/>
            <Coupon v-if="componentDisplayOnAccount==='coupon'"/>
            <Location v-if="componentDisplayOnAccount==='location'"/>
            <Subscription v-if="componentDisplayOnAccount==='subscription'"/>
            <Review v-if="componentDisplayOnAccount==='review'"/>
            <Favorites v-if="componentDisplayOnAccount==='favourites'"/>
            <Payment v-if="componentDisplayOnAccount==='paymentCards'"/>
            <AccountInfoNew v-if="componentDisplayOnAccount==='accountInfoNew'"/>
            <Friends v-if="componentDisplayOnAccount==='inviteFriends'"/>
          </div>
        </div>
      </div>


      <div class="page-container">
        <!--recommended-->
        <!-- <div v-for="(item,index) in this.$store.state.products.customCategories" v-model="local=item.Products=='local'" data-index="index" :key="index">
          <div class="Bestsellers" v-if="item.Name=='Recommended for You'">
            <div class="page-width">
              <div v-if="item.IsButton==false && item.Products.length>0" class="padding">
                 <div class="recommended-title">
                  <p v-if='$i18n.locale=="en"'>{{item.Name}}</p>
                  <p v-if='$i18n.locale=="ch"'>{{item.Description}}</p>
                </div>
                <swiper :options="productSwiper" ref="mySwiper">
                  <swiper-slide v-for="(p, index) in item.Products" :key="index" v-if="!p.IsStopSale">
                    <productCard v-if='$i18n.locale=="en"'
                      v-bind:img="p.Thumbnail"
                      v-bind:link="p.link"
                      v-bind:name="p.Name"
                      v-bind:isPromotion="p.isPromotion"
                      v-bind:price="p.Price"
                      v-bind:item="p"
                      v-bind:inCart="inCart"
                      v-bind:quantity="p.Quantity"
                      v-bind:key="index"
                    ></productCard>
                    <productCard v-if='$i18n.locale=="ch"'
                      v-bind:img="p.Thumbnail"
                      v-bind:link="p.link"
                      v-bind:name="p.Description"
                      v-bind:isPromotion="p.isPromotion"
                      v-bind:price="p.Price"
                      v-bind:item="p"
                      v-bind:inCart="inCart"
                      v-bind:quantity="p.Quantity"
                      v-bind:key="index"
                    ></productCard>
                  </swiper-slide>
                </swiper>
                 <div class="swiper-button-prev swp1">
                    <font-awesome-icon icon="arrow-left" v-if="item.Products.length>5"  :style="{ color: '#6e6b69', fontSize: '30px',  }"/>
                  </div>
                  <div class="swiper-button-next swp1">
                    <font-awesome-icon icon="arrow-right" v-if="item.Products.length>5"  :style="{ color: '#6e6b69', fontSize: '30px',  }"/>
                  </div>
              </div>
            </div>
          </div>
        </div> -->
        <!--end recommended-->
      </div>

    </div>
    <div class="profileMb">
      <mbHeader :title="loggedIn === true ? '':$t('myAccount')" :color="true" :lang="true"></mbHeader>
      <div v-if="loggedIn === true">
        <!--      Account-->
        <div class="myinfo">
          <font-awesome-icon class="icon-hover" icon="user" :style="{ color: 'black', fontSize: '18px' }"/>
          <div>
            <span>{{ this.userDetails.FirstName }}</span>
            <div class="myinfo-accountInfoIcon">
              <p @click="$router.push({path:'/mobileUserinfo'})" class="myinfo-accountInfoNew"></p>
            </div>
          </div>

        </div>
        <div class="operation">
          <div class="operItem" @click="$router.push({path:'/mobileCustomer'})">
            <div class="opericon">
              <img src="../../assets/img/operation1.png" alt="">
            </div>
            <span>{{ $t('customer_service') }}</span>
          </div>
          <div class="operItem" @click="$router.push({path:'/mobileCoupon'})">
            <div class="opericon">
              <img src="../../assets/img/operation2.png" alt="">
            </div>
            <span>{{ $t('coupon') }}</span>
          </div>
          <div class="operItem" @click="$router.push({path:'/mobileLocations'})">
            <div class="opericon">
              <img src="../../assets/img/operation3.png" alt="">
            </div>
            <span>{{ $t('afm_locations') }}</span>
          </div>
          <div class="operItem" @click="$router.push({path:'/mobileEmail'})">
            <div class="opericon">
              <img src="../../assets/img/operation4.png" alt="">
            </div>
            <span>{{ $t('email_subscription') }}</span>
          </div>
        </div>
        <div class="infoList">
          <div class="infoItem" @click="$router.push({path:'/mobileOrder'})">
            <div class="label">{{ $t('myOrders') }}</div>
            <div class="arrowr"><img src="../../assets/img/account_arrow1.png" alt=""></div>
          </div>
          <!-- <div class="infoItem advertising">
            <div class="color">
              <div class="text1">$10 OFF THE FIRST ORDER</div>
              <div class="text2">A GIFT FROM SHOPAFM</div>
            </div>
            <img src="../../assets/img/account1.png" alt="" class="rightImg">
          </div> -->
          <div class="infoItem" @click="$router.push({path:'/mobileFriends'})">
          <!-- <div v-if="this.testing === 'http://localhost:8080'" class="infoItem" @click="$router.push({path:'/mobileFriends'})"> -->
            <div class="label">{{ $t('inviteFriends') }}</div>
            <div class="arrowr"><img src="../../assets/img/account_arrow1.png" alt=""></div>
          </div>
          <div class="infoItem" @click="$router.push({path:'/mobileAddress'})">
            <div class="label">{{ $t('address_manage') }}</div>
            <div class="arrowr"><img src="../../assets/img/account_arrow1.png" alt=""></div>
          </div>
          <div class="infoItem" @click="$router.push({path:'/mobilePayment'})">
            <div class="label">{{ $t('payment_manage') }}</div>
            <div class="arrowr"><img src="../../assets/img/account_arrow1.png" alt=""></div>
          </div>
          <div class="infoItem" @click="$router.push({path:'/mobileReview'})">
            <div class="label">{{ $t('review_manage') }}</div>
            <div class="arrowr"><img src="../../assets/img/account_arrow1.png" alt=""></div>
          </div>
          <div class="infoItem" @click="$router.push({path:'/favorite'})">
            <div class="label">{{ $t('favourites_manage') }}</div>
            <div class="arrowr"><img src="../../assets/img/account_arrow1.png" alt=""></div>
          </div>
          <div class="infoItem" @click="$router.push({path:'/notifications'})">
            <div class="label">{{ $t('notifications_manage') }}</div>
            <div class="arrowr"><img src="../../assets/img/account_arrow1.png" alt=""></div>
          </div>

          <div class="infoItem logout" @click="signOut">
            <div class="label">{{ $t('Logout') }}</div>
          </div>
        </div>
      </div>
      <div class="noLogin" v-else>
        <!-- <button @click="showLogin">{{ $t('sign_up') }}/{{ $t('log_in') }}</button> -->
        <button @click="showLogin">{{ $t('log_in') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex';

import breadcrumb from "@/components/breadcrumb";
import Address from './address';
import AddressNew from './addressNew';
import Information from './information';
import Order from './order';
import productCard from "../productCard";
import temp from '../../assets/img/user.png';
import {isUserAuthenticated, flyToElement} from "../../store/modules/cart";
import Coupon from './coupon';
import CustomerService from './customerService';
import Location from './location';
import Subscription from './emailSubscription';
import Review from './reviewProducts';
import Friends from './inviteFriends.vue';
import Favorites from './favorites';
import Payment from './payment';
import AccountInfoNew from './accountInfoNew';
import mbHeader from "../../components/mobile/mbHeader";
import loginNew from '../loginNew';

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export default {
  name: 'profile',
  components: {
    breadcrumb,
    Order,
    Address,
    AddressNew,
    Information,
    productCard,
    CustomerService,
    Coupon,
    Location,
    Subscription,
    Review,
    Friends,
    Favorites,
    Payment,
    AccountInfoNew,
    mbHeader,
    loginNew,
  },
  data() {
    return {
      testing: '',
      path2: this.$t('account'),
      currentTab: "order",
      temp: temp,
      isMobile: isMobile,
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp1',
          prevEl: '.swiper-button-prev.swp1',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480: {
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      inCart: null,
    }
  },
  methods: {
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapActions('profile', ['updateUserPhoto']),
    ...mapMutations('navbar', ['handleNavToAccountFromNavbar', 'toggleLoginModalVisibility']),
    ...mapMutations('auth', ['logout']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapMutations('products', ['updateActiveProduct']),
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
        });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
    findRightElement(item, p) {
      if (item.Product_id === p) {
        return
      }
    },
    addToCart: function (item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
          .then(() => {
            flyToElement(event.target, $('.cart-link'));
          })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
          .then(() => {
            this.$store.dispatch('cart/getCart');
            flyToElement(event.target, $('.cart-link'));
          })
      }
    },
    uploadImg() {
      this.$refs.uploadInput.click()
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })
    },
    async fileChange() {
      const file = await this.toBase64(this.$refs.uploadInput.files[0]);
      this.updateUserPhoto({"profile": file})
        .then(res => {
          this.temp = res.data;
        })
        .catch(err => {
          console.log('err updating user photo', err)
        })
    },
    //Sign out User
    signOut() {
      this.logout();
    },
    showLogin() {
      this.toggleLoginModalVisibility(true)
    }
  },
  computed: mapState({
    componentDisplayOnAccount: state => state.navbar.componentDisplayOnAccount,
    cartProductsList: state => state.cart.cartProductsList,
    token: state => state.auth.token,
    itemCount: state => state.cart.itemCount,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cartClicked: state => state.cart.cartClicked,
    itemAdded: state => state.cart.itemAdded,
    userDetails: state => state.auth.userDetails,
    loggedIn: state => state.auth.loggedIn,
  }),
  mounted() {
    this.testing = window.location.origin;
    this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});
    if (this.userDetails) {
      this.temp = this.userDetails.profile_picture
    }
    if (this.$route.params.component) {
      this.handleNavToAccountFromNavbar(this.$route.params.component);
    }
    this.$root.handleNavToAccountFromNavbar = this.handleNavToAccountFromNavbar.bind(this);
  },
  watch: {
    itemCount: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        } else {
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    '$store.state.auth.userDetails': {
      immidiate: true,
      handler(newval) {
        this.temp = newval.profile_picture;
      }
    },
    $route(to, from) {
      if (to.path === '/account' && this.$route.params.component) {
        this.handleNavToAccountFromNavbar(this.$route.params.component);
      }
      if (from.path === '/account') {
        this.handleNavToAccountFromNavbar('orders');
      }
    },
  }
}
</script>

<style lang="less" scope>
@import "../../assets/css/profile.less";
@import "../../assets/css/home.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/index.vue